import { Outlet } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Noise } from "@/components/Noise";

export default function Layout() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <Noise />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </ReactLenis>
  );
}
